import { useEffect, useState } from 'react';

type ExternalValues = {
  showLabels?: boolean;
  showNumbers?: boolean;
  dragPan?: boolean;
  label?: string;
  icon?: string;
};

export const useExternalValue = (keyword: string): Array<ExternalValues> | undefined => {
  const [items, setItems] = useState(undefined);
  useEffect(() => {
    if (keyword.length > 0) {
      (async () => {
        const response = await fetch('/configuration/variations.json');
        try {
          const data = await response.json();
          setItems(data[keyword]);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      })();
    }
  }, [keyword]);
  return items;
};

export const useExternalBoolean = (keyword: string): boolean | undefined => {
  const [items, setItems] = useState(undefined);
  useEffect(() => {
    if (keyword.length > 0) {
      (async () => {
        const response = await fetch('/configuration/variations.json');
        try {
          const data = await response.json();
          if (data['map-cluster-numbers']) setItems(data['map-cluster-numbers'][keyword]);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      })();
    }
  }, [keyword]);
  return items;
};

export const useExternalBooleanLabels = (keyword: string): boolean | undefined => {
  const [items, setItems] = useState(undefined);
  useEffect(() => {
    if (keyword.length > 0) {
      (async () => {
        const response = await fetch('/configuration/variations.json');
        try {
          const data = await response.json();
          if (data['map-cluster-label']) setItems(data['map-cluster-label'][keyword]);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      })();
    }
  }, [keyword]);
  return items;
};

export const useExternalBooleanDragPan = (keyword: string): boolean | undefined => {
  const [items, setItems] = useState(undefined);
  useEffect(() => {
    if (keyword.length > 0) {
      (async () => {
        const response = await fetch('/configuration/variations.json');
        try {
          const data = await response.json();
          if (data['map-dragPan']) setItems(data['map-dragPan'][keyword]);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      })();
    }
  }, [keyword]);
  return items;
};
